import React, { useContext } from 'react';
import { homePageData, promoTextHeader } from '../assets/dummyData/homePage';
import { boxes, HpMapData } from '../assets/dummyData/HpBoxesData';
import { locations } from '../assets/dummyData/map';

import Header from '../components/Header/Header';
import HpAbout from '../components/HpAbout/HpAbout';
import HpBoxes from '../components/HpBoxes/HpBoxes';
import HpMap from '../components/Hpmap/HpMap';
import { Context } from '../context/Products';
import Helmet from "../components/Helmet";
import { seo } from '../assets/dummyData/seo';

const HomePage = () => {
  const [{ lang }] = useContext(Context);
  return (
    <div id="page-hp" className="page">
        <Helmet
          title={seo[lang].home.title}
          metaDesc={seo[lang].home.description}
          lang={lang}
        />
        <Header promoText={promoTextHeader[lang]} />
        <HpAbout
          data={homePageData[lang]}
        />
        <HpBoxes
          boxes={boxes[lang]}
          title={boxes.title[lang]}
        />
        <div className="clearfix" />
        <HpMap data={HpMapData[lang]} locations={locations[lang]} />
    </div>
  )
}

export default HomePage;
